import { render, staticRenderFns } from "./FailedDeliveryConfiguration.vue?vue&type=template&id=0bbc7eba&scoped=true&"
import script from "./FailedDeliveryConfiguration.vue?vue&type=script&lang=js&"
export * from "./FailedDeliveryConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./FailedDeliveryConfiguration.vue?vue&type=style&index=0&id=0bbc7eba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbc7eba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbc7eba')) {
      api.createRecord('0bbc7eba', component.options)
    } else {
      api.reload('0bbc7eba', component.options)
    }
    module.hot.accept("./FailedDeliveryConfiguration.vue?vue&type=template&id=0bbc7eba&scoped=true&", function () {
      api.rerender('0bbc7eba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/FailedDeliveryConfiguration.vue"
export default component.exports